import { IoStatsChart } from 'react-icons/io5';
import { useTranslation } from "react-i18next";

const MonthlyStats = ({ data }) => {
    const { t } = useTranslation();
    return (
        <div className="bg-primary-800 border border-primary-50 rounded-2xl p-4 mb-4">
            <div className="flex mb-4 items-center">
                <div className="rounded-xl p-2 text-2xl bg-purple-50 text-purple-800">
                    <IoStatsChart />
                </div>
                <div className="ml-2">
                    <h3 className="text-white">
                        {t('reports.monthly_stats')}
                    </h3>
                    <p className="text-primary-10 text-xs">{t('reports.monthly_stats_desc')}</p>
                </div>
            </div>
            <table className="w-full text-left mt-4 border-spacing-y-4">
                <thead>
                    <tr className="text-primary-10 text-xs border-b border-separate border-primary-50">
                        <th>MEMBER</th>
                        <th>HOUSES</th>
                        <th>TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index} className="font-mono text-base">
                            <td className="text-white">{row.name}</td>
                            <td className="text-secondary-800">{row.total_houses}</td>
                            <td className="text-success-800">${row.total_amount}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default MonthlyStats;